var map = {
	"./Airport_Shipyard/Cochin_Shipyard/1.jpeg": "72df",
	"./Airport_Shipyard/Cochin_airport/1.jpg": "d445",
	"./Airport_Shipyard/Cochin_airport/2.jpg": "fe93",
	"./Airport_Shipyard/Kannur_airport/1.jpg": "eb5b",
	"./Airport_Shipyard/Kannur_airport/2.jpg": "6f1a",
	"./Airport_Shipyard/Kannur_airport/3.jpg": "4f6c",
	"./Airport_Shipyard/calicut_international_airport/1.jpg": "1aa0",
	"./Airport_Shipyard/mumbai_airport/1.jpeg": "985a",
	"./Airport_Shipyard/petronet_lng/1.png": "7209",
	"./Believers-Church-Seminary-and-School.jpg": "86ea",
	"./Central-Marine-Fisheries-Research-Institute-(CMFRI).jpg": "c3f8",
	"./City-Marriott-Hotel-Kochi.jpg": "1876",
	"./Cochin-Shipyard-Ltd.jpg": "2299",
	"./DM-Healthcare-Pvt-Ltd.jpg": "4bb1",
	"./ESAF.jpg": "49302",
	"./Emmay-Logistics.jpg": "bfa9",
	"./Federal-Bank.jpg": "dc54",
	"./Hotel-Olive-Downtown.jpg": "b210",
	"./Hyatt-Regency-and-Lulu-Convention-Center.jpg": "23ec",
	"./Incheon-Motors.jpg": "88a3",
	"./Indian-Navy.jpg": "6d4b",
	"./Kasargod-Medical-College-(Kitco).jpg": "c758",
	"./Kerala-Sec.jpg": "227f",
	"./LPSC.jpg": "77ca",
	"./Lakeshore-Hospitals.jpg": "b7b6",
	"./Larsen-&-Toubro.jpg": "9354",
	"./Lulu-Flight-Kitchen.jpg": "d1c9",
	"./Lulu-mall-kochi.jpg": "50d1",
	"./MG-University.jpg": "372b",
	"./MVR-Cancer-Center.jpg": "a075",
	"./MVR-Palliative-Care.jpg": "65f2",
	"./Mall-of-Joy.jpg": "9867",
	"./Marriott-Hotel-Courtyard.jpg": "aa35",
	"./Providence-College-of-Engineering.jpg": "e6e1",
	"./South-Indian-Bank.jpg": "865d",
	"./TAJ-Hotel-Wayanad.jpg": "8746",
	"./V-Guard-Industries-Ltd.jpg": "0d90",
	"./corporate/L_T/1.jpg": "6b61",
	"./corporate/Parle_agro/1.jpg": "df46",
	"./corporate/Shapoorji_pallonji/1.jpg": "f0d5",
	"./corporate/V-Guard/1.jpg": "c402",
	"./corporate/Voltas/1.png": "a554",
	"./corporate/lufthansa/1.jpg": "d6f5",
	"./corporate/lufthansa/2.jpg": "6e20",
	"./corporate/raymond/1.jpg": "c334",
	"./corporate/reliance_industries/1.jpg": "f0c4",
	"./corporate/reliance_industries/2.jpg": "05c4",
	"./corporate/shell_india/1.jpg": "b270",
	"./education/Govt_college_of_engg_srikrishnapuram/1.jpg": "c9c0",
	"./education/MG_U.city/1.jpg": "fd1b",
	"./education/MG_U.city/2.jpg": "ed5a",
	"./education/believers/1.jpg": "531a",
	"./education/lakshadweep_school/1.jpg": "7447",
	"./education/providence_college_of_engg/1.jpg": "fc2c",
	"./education/providence_college_of_engg/2.jpg": "3452",
	"./education/sanskrit_college/1.jpeg": "562f",
	"./education/sanskrit_college/2.jpg": "f8b2",
	"./finance/DHANAKSHMI/1.jpg": "029a",
	"./finance/ESAF/1.jpg": "4e85",
	"./finance/South_indian_bank/1.jpg": "c6cc",
	"./finance/axis.png": "a614",
	"./finance/axis2.jpg": "c3a2",
	"./finance/axis3.jpeg": "46ab",
	"./finance/canara.jpg": "a952",
	"./finance/canara.png": "93d8",
	"./finance/canara2.jpg": "e6a8",
	"./finance/federal_bank/1.jpg": "f490",
	"./finance/ksfe.jpeg": "7d67",
	"./finance/ksfe2.jpeg": "5701",
	"./finance/oriental.png": "c2d2",
	"./finance/union_bank/1.jpg": "bfd1",
	"./govt/cmfri.jpg": "61ab",
	"./govt/coir-board.jpg": "1226",
	"./govt/hal.jpg": "3c77",
	"./govt/india-post.jpg": "6f0d",
	"./govt/indian-navy.jpg": "d988",
	"./govt/irel.jpg": "6fc8",
	"./govt/kerala-gov.jpg": "1d8e",
	"./govt/lpsc.jpg": "82e7",
	"./govt/office-of-textile.jpg": "ca94",
	"./govt/prasarbharati.jpg": "6bee",
	"./healthcare/GT Hospital/1.jpg": "4a59",
	"./healthcare/Glenmark/1.jpg": "2ebc",
	"./healthcare/Mar Sleeva medicity/1.jpg": "09a6",
	"./healthcare/Welcare hostital/1.jpg": "f963",
	"./healthcare/dm/1.jpg": "8eec",
	"./healthcare/kasargod medical college/1.jpg": "bcb2",
	"./healthcare/lakeshore hospital/1.jpg": "96b1",
	"./healthcare/mvr cancer centre/1.jpg": "b8e8",
	"./healthcare/mvr palliative/1.jpg": "a35f",
	"./healthcare/pushpagiri medical college/1.jpg": "6358",
	"./healthcare/rajagiri hospital/1.jpg": "d624",
	"./healthcare/st.george hospital/1.jpg": "9094",
	"./hospitality/City_marriot_hotel_kochi/1.jpg": "1bc1",
	"./hospitality/Grand_Hyatt/1.jpg": "c70f",
	"./hospitality/Hotel_Mirador/1.jpg": "7f2e",
	"./hospitality/Hotel_diplomat/1.jpeg": "00e8",
	"./hospitality/Hotel_olive_down_town/1.jpg": "ba76",
	"./hospitality/Hyatt_regency_Lulu_convention_centre/1.jpeg": "2c23",
	"./hospitality/Lulu_Flight_Kitchen/1.jpg": "9f4a",
	"./hospitality/Mariott_hotel_courtyard/1.jpg": "ed56",
	"./hospitality/Recidency_hotel/1.jpg": "2869",
	"./hospitality/hotel_oberoi/1.jpg": "345c",
	"./hospitality/taj_hotel_wayanad/1.jpg": "088e",
	"./shopping_mall_IT_infra/Lulu_mall/1.jpeg": "b134",
	"./shopping_mall_IT_infra/Mantle_solution/1.jpg": "6dec",
	"./shopping_mall_IT_infra/Mariapps/1.jpg": "3f37",
	"./shopping_mall_IT_infra/Nippon_infra/1.jpg": "551f",
	"./shopping_mall_IT_infra/Y-mall/1.jpg": "8ef8",
	"./shopping_mall_IT_infra/accenture/1.jpg": "ca04",
	"./shopping_mall_IT_infra/mall_of_joy/1.jpg": "fa30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8763";